'use es6';

import { Component, createRef } from 'react';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import I18n from 'I18n';
import { EERIE } from 'visitor-ui-component-library/constants/WidgetColors';
import { reportError } from 'conversations-error-reporting/error-reporting/reportError';
import ChatHeadingConfigPropType from 'conversations-prop-types/prop-types/ChatHeadingConfigPropType';
import AIWelcomeMessageContent from './AIWelcomeMessageContent';
import { WidgetLocationProp, LEFT_ALIGNED } from './constants/WidgetLocations';
import VizExIconButton from 'visitor-ui-component-library/button/VizExIconButton';
import WelcomeMessageAvatars from './WelcomeMessageAvatars';
import { jsx as _jsx } from "react/jsx-runtime";
const MessageBubbleContainer = styled.div.withConfig({
  displayName: "InitialMessageBubble__MessageBubbleContainer",
  componentId: "sc-1flcodu-0"
})(["display:flex;justify-content:", ";"], ({
  widgetLocation
}) => widgetLocation === LEFT_ALIGNED ? 'flex-start' : 'flex-end');
export const StyleWrapper = styled.div.withConfig({
  displayName: "InitialMessageBubble__StyleWrapper",
  componentId: "sc-1flcodu-1"
})(["position:relative;margin-top:40px;"]);
export const CloseButton = styled(VizExIconButton).withConfig({
  displayName: "InitialMessageBubble__CloseButton",
  componentId: "sc-1flcodu-2"
})(["position:absolute;top:0;right:0;width:36px;height:36px;color:", ";z-index:2;&:focus-visible{outline-offset:-2px;}"], EERIE);
export default class InitialMessageBubble extends Component {
  constructor(...args) {
    super(...args);
    this.messageBubbleContainerRef = /*#__PURE__*/createRef();
    this.onClose = () => {
      try {
        this.props.onClose();
      } catch (err) {
        reportError({
          error: 'InitialMessageBubble Mysterious Error',
          fingerprint: ['ComponentError'],
          tags: {
            componentDidCatch: true
          }
        });
      }
    };
    this.renderWelcomeMessageContent = () => {
      const {
        widgetLocation,
        initialMessage,
        onClick,
        mobile,
        chatHeadingConfig,
        chatHeadingResponders,
        publishAIInitialMessage,
        isAIChatBot,
        gdprConsentEnabled,
        isIOSMobile,
        isInPreviewMode = false,
        useDefaultColor
      } = this.props;
      const showWelcomeMessageAsButton = !isAIChatBot || isAIChatBot && gdprConsentEnabled;
      return /*#__PURE__*/_jsx(AIWelcomeMessageContent, {
        initialMessage: initialMessage,
        onClose: this.onClose,
        publishMessage: publishAIInitialMessage,
        widgetLocation: widgetLocation,
        mobile: mobile,
        isAIChatBot: isAIChatBot,
        onClick: onClick,
        gdprConsentEnabled: gdprConsentEnabled,
        isIOSMobile: isIOSMobile,
        showWelcomeMessageAsButton: showWelcomeMessageAsButton,
        avatarsCount: (chatHeadingResponders === null || chatHeadingResponders === void 0 ? void 0 : chatHeadingResponders.size) || 1,
        isInPreviewMode: isInPreviewMode,
        messageBubbleContainerRef: this.messageBubbleContainerRef,
        useDefaultColor: useDefaultColor,
        children: /*#__PURE__*/_jsx(WelcomeMessageAvatars, {
          chatHeadingConfig: chatHeadingConfig,
          chatHeadingResponders: chatHeadingResponders,
          mobile: mobile,
          onClick: onClick
        })
      });
    };
  }
  componentDidMount() {
    this.props.onUpdateSize();
  }
  componentDidUpdate(nextProps) {
    if (nextProps.initialMessage !== this.props.initialMessage) {
      this.props.onUpdateSize();
    }
  }
  render() {
    const {
      mobile,
      widgetLocation,
      isAIChatBot
    } = this.props;
    return /*#__PURE__*/_jsx(MessageBubbleContainer, {
      ref: this.messageBubbleContainerRef,
      widgetLocation: widgetLocation,
      children: /*#__PURE__*/_jsx(StyleWrapper, {
        className: mobile ? "mobile" : "",
        "aria-label": I18n.text('conversations-visitor-experience-components.visitorExperienceAriaLabels.welcomeMessage'),
        role: "status",
        widgetLocation: widgetLocation,
        isAIChatBot: isAIChatBot,
        mobile: mobile,
        children: this.renderWelcomeMessageContent()
      })
    });
  }
}
InitialMessageBubble.displayName = 'InitialMessageBubble';
InitialMessageBubble.propTypes = {
  chatHeadingConfig: ChatHeadingConfigPropType.isRequired,
  chatHeadingResponders: PropTypes.instanceOf(List).isRequired,
  gdprConsentEnabled: PropTypes.bool.isRequired,
  initialMessage: PropTypes.string.isRequired,
  isAIChatBot: PropTypes.bool.isRequired,
  isIOSMobile: PropTypes.bool.isRequired,
  isInPreviewMode: PropTypes.bool,
  mobile: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onUpdateSize: PropTypes.func.isRequired,
  publishAIInitialMessage: PropTypes.func.isRequired,
  useDefaultColor: PropTypes.bool.isRequired,
  widgetLocation: WidgetLocationProp
};
InitialMessageBubble.defaultProps = {
  mobile: false,
  onUpdateSize: () => {}
};